var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachmentAfter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18V2C0 2 0 0 2 0C4 0 4 2 4 2V18C4 21.3137 6.68628 24 10 24C13.3137 24 16 21.3137 16 18V6C16 4.89544 15.1046 4 14 4C12.8954 4 12 4.89544 12 6V20C12 20 12 22 10 22C8 22 8 20 8 20V6C8 2.68629 10.6863 0 14 0C17.3137 0 20 2.68629 20 6V18C20 23.5228 15.5228 28 10 28C4.47716 28 0 23.5228 0 18Z",
    fill: "#727272"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 0H24V18C24 25.732 17.732 32 10 32H4V54C4 57.3136 6.68628 60 10 60H50C53.3136 60 56 57.3136 56 54V6C56 2.68629 53.3136 0 50 0ZM44 16H28V20H44V16ZM44 28H28V32H44V28ZM16 40H44V44H16V40Z",
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentAfter);
export default __webpack_public_path__ + "static/media/Attachment-After.f21345d5e06e447f6e86578f0774aad7.svg";
export { ForwardRef as ReactComponent };